import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MediaQuerySize from '../../components/media-query-size/media-query-size';
import { sizeChanged } from '../../lib/media-query/actions';

class MediaQueryContainer extends Component {
  constructor(props) {
    super(props);
    this.onSizeChange = this.onSizeChange.bind(this);
  }

  onSizeChange(newSize) {
    this.props.dispatch(sizeChanged(newSize));
  }

  render() {
    return <MediaQuerySize onSizeChange={this.onSizeChange} />;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
MediaQueryContainer.propTypes = {
  dispatch: PropTypes.func,
};

export default connect(null)(MediaQueryContainer);
